module.exports = __webpack_public_path__ + "img/feature_buy_zh.0b9ff0ef.png";